import React, { useState } from 'react';

const BeforeAfterSlider = ({
  lang = 'en',
  beforeImage,
  afterImage,
  beforeLabel = 'Before',
  afterLabel = 'After',
}) => {
  const isAr = lang === 'ar';
  // If Arabic, we start the slider from the other side or keep it centered
  const [sliderPosition, setSliderPosition] = useState(50);
  const [isDragging, setIsDragging] = useState(false);

  const handleMove = (e) => {
    if (!isDragging) return;

    const container = e.currentTarget.getBoundingClientRect();
    // Support for both Mouse and Touch events
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const relativeX = clientX - container.left;

    const percentage = Math.min(
      Math.max((relativeX / container.width) * 100, 0),
      100,
    );
    setSliderPosition(percentage);
  };

  return (
    <div
      className='relative w-full h-64 md:h-96 rounded-2xl overflow-hidden group shadow-2xl select-none'
      dir='ltr' // Keep the container LTR so the X-axis math works easily
    >
      {/* Background Image (The "Before" or original state) */}
      <div className='absolute inset-0'>
        <img
          src={beforeImage}
          alt='Before cleaning'
          className='w-full h-full object-cover'
        />
        {/* Before Label - Positions based on language */}
        <div
          className={`absolute top-4 ${isAr ? 'right-4' : 'left-4'} px-4 py-1.5 bg-black/70 text-white rounded-full text-xs font-bold uppercase tracking-wider backdrop-blur-md`}
        >
          {isAr ? 'قبل' : beforeLabel}
        </div>
      </div>

      {/* Foreground Image (The "After" or cleaned state) */}
      <div
        className='absolute inset-0 overflow-hidden border-r-2 border-white/50'
        style={{ width: `${sliderPosition}%` }}
      >
        <div className='w-[100vw] h-full relative'>
          {/* We use a fixed width container inside the clip to prevent image shrinking */}
          <img
            src={afterImage}
            alt='After cleaning'
            className='absolute inset-0 w-full h-full object-cover'
            style={{ width: 'calc(100% * (100 / ' + sliderPosition + '))' }}
          />
        </div>

        {/* After Label - Positions based on language */}
        <div
          className={`absolute top-4 ${isAr ? 'left-4' : 'right-4'} px-4 py-1.5 bg-royal-purple-600 text-white rounded-full text-xs font-bold uppercase tracking-wider shadow-lg`}
        >
          {isAr ? 'بعد' : afterLabel}
        </div>
      </div>

      {/* Slider Handle Bar */}
      <div
        className='absolute top-0 bottom-0 w-1 bg-white cursor-col-resize z-20'
        style={{ left: `${sliderPosition}%` }}
      >
        <div className='absolute top-1/2 -translate-y-1/2 -translate-x-1/2 w-10 h-10 bg-white rounded-full shadow-2xl flex items-center justify-center border-4 border-royal-purple-500'>
          <div className='flex space-x-1'>
            {[...Array(3)].map((_, i) => (
              <div
                key={i}
                className='w-0.5 h-4 bg-royal-purple-500 rounded-full'
              />
            ))}
          </div>
        </div>
      </div>

      {/* Event Overlay */}
      <div
        className='absolute inset-0 cursor-col-resize z-30'
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseDown={() => setIsDragging(true)}
        onTouchStart={() => setIsDragging(true)}
        onMouseUp={() => setIsDragging(false)}
        onTouchEnd={() => setIsDragging(false)}
        onMouseLeave={() => setIsDragging(false)}
      />
    </div>
  );
};

export default BeforeAfterSlider;
